<section class="fvr-card fvr-list fvr-deviations" [attr.aria-busy]="loading">
  <header class="fvr-list__head">
    <h2 class="fvr-title">
      {{ "FLEXI_SAFETY_ROUNDS.DEVIATIONS.TAB" | translate }}
    </h2>
    <p class="fvr-subtitle">
      {{ "FLEXI_SAFETY_ROUNDS.DEVIATIONS.INTRO" | translate }}
    </p>
  </header>
  <form (ngSubmit)="search()" class="fvr-deviation-filters">
    <label
      >{{ "FLEXI_SAFETY_ROUNDS.DEVIATIONS.SEARCH" | translate }}
      <input
        name="title"
        [ngModel]="title"
        (ngModelChange)="title = $event; queueSearch()"
        type="search"
      />
    </label>
    <label
      >{{ "FLEXI_SAFETY_ROUNDS.COLUMN.STATUS" | translate }}
      <select
        name="status"
        [ngModel]="status"
        (ngModelChange)="status = $event; search()"
      >
        <option value="">
          {{ "FLEXI_SAFETY_ROUNDS.DEVIATIONS.ALL" | translate }}
        </option>
        <option
          *ngFor="let value of ['New', 'Open', 'Done', 'Rejected']"
          [value]="value"
        >
          {{
            "FLEXI_SAFETY_ROUNDS.DEVIATIONS." + value.toUpperCase() | translate
          }}
        </option>
      </select>
    </label>
    <button class="fas-btn fas-btn--primary" type="submit" [disabled]="loading">
      <i *ngIf="loading" class="pi pi-spin pi-spinner" aria-hidden="true"></i>
      {{ (loading ? 'FLEXI_SAFETY_ROUNDS.LOADING' : 'FLEXI_SAFETY_ROUNDS.DEVIATIONS.SEARCH') | translate }}
    </button>
  </form>
  <flexi-safety-round-skeleton *ngIf="loading" />
  <div *ngIf="failed" role="alert">
    <p>{{ "FLEXI_SAFETY_ROUNDS.LOAD_FAILED" | translate }}</p>
    <button type="button" class="fas-btn" (click)="load()">
      {{ "FLEXI_SAFETY_ROUNDS.ASSIGN.RETRY" | translate }}
    </button>
  </div>
  <div class="fvr-deviation-table" *ngIf="!failed && !loading">
    <table class="fvr-table">
      <thead>
        <tr>
          <th scope="col" class="fvr-deviation-number">
            {{ "FLEXI_SAFETY_ROUNDS.DEVIATIONS.NUMBER" | translate }}
          </th>
          <th scope="col">
            {{ "FLEXI_SAFETY_ROUNDS.DETAILS.TITLE" | translate }}
          </th>
          <th scope="col" class="fvr-deviation-status">
            {{ "FLEXI_SAFETY_ROUNDS.COLUMN.STATUS" | translate }}
          </th>
          <th scope="col" class="fvr-deviation-responsible">
            {{ "FLEXI_SAFETY_ROUNDS.COLUMN.RESPONSIBLE" | translate }}
          </th>
          <th scope="col" class="fvr-deviation-deadline">
            {{ "FLEXI_SAFETY_ROUNDS.DEVIATION.DEADLINE" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows">
          <td class="fvr-deviation-number">
            <a [routerLink]="deviationUrl(row.Id)">{{ row.No }}</a>
          </td>
          <td>
            <a [routerLink]="deviationUrl(row.Id)">{{ row.Title }}</a>
          </td>
          <td>
            {{
              row.Status
                ? ("FLEXI_SAFETY_ROUNDS.DEVIATIONS." + row.Status.toUpperCase()
                  | translate)
                : "—"
            }}
          </td>
          <td>{{ row.ExecutionUserName || row.ResponsiblePerson || "—" }}</td>
          <td class="fvr-deviation-deadline">
            {{ (row.Deadline | date: "dd-MM-yyyy") || "—" }}
          </td>
        </tr>
        <tr *ngIf="!rows.length">
          <td colspan="5" class="fvr-deviation-empty">
            {{ "FLEXI_SAFETY_ROUNDS.DEVIATIONS.EMPTY" | translate }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="fvr-deviation-pages" *ngIf="total > pageSize">
    <button
      type="button"
      class="fas-btn"
      [disabled]="loading || page <= 1"
      (click)="changePage(page - 1)"
    >
      {{ "FLEXI_SAFETY_ROUNDS.BACK" | translate }}
    </button>
    <span>{{ page }}</span>
    <button
      type="button"
      class="fas-btn"
      [disabled]="loading || page * pageSize >= total"
      (click)="changePage(page + 1)"
    >
      {{ "FLEXI_SAFETY_ROUNDS.NEXT" | translate }}
    </button>
  </div>
  <footer>
    <a class="fas-btn fas-btn--ghost" [routerLink]="safetyRoundsUrl">
      <i class="pi pi-arrow-left" aria-hidden="true"></i>
      {{ "FLEXI_SAFETY_ROUNDS.FINISH.TO_LIST" | translate }}
    </a>
  </footer>
</section>
